import React from 'react';
import { bemClasses } from '../../helpers';
import { Toggle } from '../../components';
import { ERROR_TEXT } from '../../constants';
var renderErrors = function (error) {
    if (!error) {
        return null;
    }
    return error
        .map(function (singleError, index) {
        var formattedError = formatErrors(singleError);
        if (!formattedError) {
            return null;
        }
        return (React.createElement("code", { className: bemClasses.element("error-content-code"), key: index }, formattedError));
    })
        .filter(Boolean);
};
export var formatErrors = function (singleError) {
    var message = singleError.message, dataPath = singleError.dataPath, params = singleError.params, keyword = singleError.keyword;
    var info = Object.values(params)[0];
    return dataPath + " " + message + (keyword === 'type' ? '' : ": " + info);
};
export var ErrorComponent = function (_a) {
    var error = _a.error;
    if (!error) {
        return null;
    }
    var className = "error";
    var message = error.message, validationError = error.validationError;
    var header = (React.createElement("h2", null,
        ERROR_TEXT,
        ": ",
        message));
    return (React.createElement("section", { className: bemClasses.element(className) },
        React.createElement(Toggle, { header: header, className: className }, !!validationError && (React.createElement("div", { className: bemClasses.element(className + "-body") },
            React.createElement("pre", { className: bemClasses.element(className + "-body-pre") }, renderErrors(validationError)))))));
};
//# sourceMappingURL=Error.js.map